<template>
    <div :id="modal_id_key" class="modal fade">
        <div class="modal-dialog modal-dialog-scrollable modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{title}}</h5>
                </div>
                <div class="modal-body">
                    <slot name="default"> Ой, нет контента для default slot </slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['title', 'show', 'modal_id'],
  data () {
    return {
      is_shown: this.show,
      modal_id_key: this.modal_id == undefined ? 'main-modal' : this.modal_id
    }
  },
  watch:{
      show: function(val) {
        this.is_shown = val;
      },
  },
  mounted: function() {
    var vc = this;
    $(`#${vc.modal_id_key}`).on('hidden.bs.modal', function (e) {
      vc.is_shown = false;
      vc.$emit('modal_hide');
    });

    $(`#${vc.modal_id_key}`).on('shown.bs.modal', function (e) {
      vc.is_shown = true;
    });

    this.toggle();
  },
  updated: function() {
    this.toggle();
  },
  beforeUpdate: function() {
    this.is_shown = this.$props.show;
  },
  methods: {
    toggle: function() {
        if (this.is_shown) {
            $(`#${this.modal_id_key}`).modal('show');
        } else {
            $(`#${this.modal_id_key}`).modal('hide');
        }
    }
  }
}
</script>

